<template>
  <div class="modalbody">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'modal-body'
}
</script>

<style>
.modalbody {
  max-height: 80vh;
  overflow: auto;
}
</style>